module.exports = __webpack_public_path__ + "static/media/map14.585815c8.webp";